/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { of, throwError } from "rxjs";
import { ApplicationError } from "../../../../models/ui/application-error.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import {
	GET_METRIC_DATA_RESPONSE,
	GET_METRIC_OVERVIEW_RESPONSE,
	GET_SITE_LIST_RESPONSE
} from "./dashboard-data-center.db";

const CLASS_NAME = "DashboardDataCenter";

export class DashboardDataCenter {
	public static getSiteList() {
		return of(GET_SITE_LIST_RESPONSE);
	}

	public static getMetricOverview() {
		return of(GET_METRIC_OVERVIEW_RESPONSE);
	}

	public static getMetricData(options: HttpRequestOptions) {
		const httpParams = options.params as HttpParams;
		const siteId = httpParams?.get("siteId");

		if (!siteId) {
			return throwError(
				() =>
					new ApplicationError("Missing required parameters", CLASS_NAME, "getMetricData")
			);
		}

		return of(GET_METRIC_DATA_RESPONSE);
	}
}
